/**
 * Created by Vladislav on 5/17/2024.
 */

const Country = function () {
    cleverapps.EventEmitter.call(this);

    this.country = undefined;

    this.load();

    this.update();
};

Country.prototype = Object.create(cleverapps.EventEmitter.prototype);
Country.prototype.constructor = Country;

Country.prototype.update = function () {
    connector.multi.getCountry((success, countryCode) => {
        console.log("countryCode", success, countryCode);

        if (countryCode) {
            this.setCountry(countryCode);
        }
    });
};

Country.prototype.whenReady = function (callback) {
    if (this.country) {
        callback(this.country);
    } else {
        this.once("update", callback);
    }
};

Country.prototype.getCountry = function () {
    return this.country;
};

Country.prototype.setCountry = function (country) {
    if (this.country !== country) {
        this.country = country;

        this.save();

        this.trigger("update", country);
    }
};

Country.prototype.load = function () {
    const info = cleverapps.dataLoader.load(DataLoader.TYPES.COUNTRY);
    if (info && info.country) {
        this.country = info.country;
    }
};

Country.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.COUNTRY, {
        country: this.country
    });
};

Country.prototype.getCountryTier = function () {
    const country = this.getCountry();

    if (country !== undefined) {
        for (const [tier, countries] of Object.entries(Country.COUNTRY_TIERS)) {
            if (countries.includes(country)) {
                return tier;
            }
        }
    }

    return "T4";
};

Country.COUNTRY_TIERS = {
    "T1": ["AU", "CA", "DK", "FR", "DE", "NL", "NO", "SE", "GB", "US", "AT", "BE", "FI", "IE", "JP", "NZ", "CH", "KR", "LU"],
    "T2": ["CY", "CZ", "EE", "HK", "HU", "IS", "IL", "IT", "KW", "PL", "PR", "SG", "ZA", "ES", "AE", "GR", "LV", "LT", "MT", "PT", "SA", "SI", "SK", "TW", "MC", "QA", "OM", "GL"],
    "T3": [
        "AR", "BR", "BG", "CL", "CN", "CO", "CR", "DO", "EC", "GH", "BY", "HN", "ID", "IQ", "JM", "JO", "KE", "AL",
        "LB", "SV", "NG", "MU", "MX", "MA", "NI", "PA", "PY", "PE", "HR", "RO", "KZ", "TH", "TN", "TR", "UA", "UY",
        "VE", "VN", "RU", "MY", "AM", "AZ", "BA", "RS"
    ],
    "T4": []
};